import '.c0{flex-shrink:0;}.ssr-plugin'
import '.c1{padding:1rem;}.ssr-plugin'
import '.a4{width:100%;}.ssr-plugin'
import '.bm{height:100%;}.ssr-plugin'
import '.av{border:none;}.ssr-plugin'
import '.aw{background-color:transparent;}.ssr-plugin'
import '.fq{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.de{position:sticky;}.ssr-plugin'
import '.fr{top:4rem;}.ssr-plugin'
import '.fs{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.ft{padding-bottom:1rem;}.ssr-plugin'
import '.a8{margin-bottom:1rem;}.ssr-plugin'
import '.fu{border-bottom:var(--blue-border);}.ssr-plugin'
import '.x{position:fixed;}.ssr-plugin'
import '.cj{top:0;}.ssr-plugin'
import '.bk{left:0px;}.ssr-plugin'
import '.bl{right:0px;}.ssr-plugin'
import '.fv{bottom:0px;}.ssr-plugin'
import '.f6{z-index:9999;}.ssr-plugin'
import '.fw{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.d3{justify-content:flex-end;}.ssr-plugin'
import '.c2{flex:1;}.ssr-plugin'
import '.ar{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="c0 c1 a4 bm av aw fq"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ab"
    >
      <div className="de fr fs ae ft a8 fu a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="x cj bk bl fv f6 ae fw a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="c1 a d3 fu"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="c2 ar">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
